import configuration from "./index";
import { authFetch } from "../utils/authFetch";

export const NotesAPI = {
  delete: async function (problem, outage, noteID) {
    let requestOptions = {
      method: "DELETE",
      headers: { "Content-type": "application/json" },
    };

    const response = await authFetch(
      configuration.apiBase +
        `/problem/${problem}/outage/${outage}/note/${noteID}`,
      requestOptions
    )
      .then((res) => {
        if (!res.ok) {
          console.log(res);
        }
        return res;
      })
      .then((res) => res.json());
    return response;
  },
  get: async function (problem, outage) {
    let requestOptions = {
      method: "GET",
      headers: { "Content-type": "application/json" },
    };

    const apiURL =
      configuration.apiBase + `/problem/${problem}/outage/${outage}/notes`;

    const response = await authFetch(apiURL, requestOptions)
      .then((res) => {
        if (!res.ok) {
          console.log(res);
        }
        return res;
      })
      .then((res) => res.json());
    return response;
  },
  post: async function (problem, outage, note) {
    if (typeof note.created === "object") {
      note.created = note.created.getTime();
    }

    // Generated by GitHub Copilot
    // Retrieve user data from local storage per US1761821
    // This provides author information for the note (follows US1778248 pattern)
    let authorName = "Unknown Agent";
    let authorEmail = "unknown@coxautoinc.com";
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        authorName = user.name || "Unknown Agent";
        authorEmail = user.email || "unknown@coxautoinc.com";
      } catch (error) {
        console.error("Error parsing user from localStorage:", error);
      }
    }

    // Generated by GitHub Copilot
    // Ensure note has author information from local storage
    note.author = {
      name: authorName,
      email: authorEmail,
    };

    const payload = {
      note: note,
    };

    let requestOptions = {
      method: note.id === "" ? "POST" : "PUT",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify(payload),
    };

    const URL =
      configuration.apiBase +
      `/problem/${problem}/outage/${outage}/note` +
      (note.id !== "" ? `/${note.id}` : "s");

    const response = await authFetch(URL, requestOptions)
      .then((res) => {
        if (!res.ok) {
          // Generated by GitHub Copilot
          // Added detailed error logging per US1761821 to help debug API issues
          console.error("Note API request failed:", {
            status: res.status,
            statusText: res.statusText,
            url: URL,
            method: requestOptions.method,
          });

          if (res.status !== 401) {
            // Generated by GitHub Copilot
            // Fixed: Use res.statusText instead of undefined response variable
            throw Error(`Failed to save note: ${res.status} ${res.statusText}`);
          }

          window.localStorage.setItem("destination", window.location.href);
          // we got a 401 so they need to  login
          window.location.href = "/signin/login";
          throw Error("Not Logged In");
        }

        return res;
      })
      .then((res) => res.json());
    return response;
  },
};
